// extracted by mini-css-extract-plugin
export var avatarContainer = "_7r-0";
export var avatarTypingWave = "_7r-i";
export var gray = "_7r-f";
export var green = "_7r-c";
export var icon = "_7r-9";
export var image = "_7r-1";
export var lg = "_7r-6";
export var md = "_7r-5";
export var presenceDot = "_7r-b";
export var red = "_7r-d";
export var sm = "_7r-4";
export var status = "_7r-a";
export var typingDot = "_7r-h";
export var typingPill = "_7r-g";
export var xl = "_7r-7";
export var xs = "_7r-3";
export var xxl = "_7r-8";
export var xxs = "_7r-2";
export var yellow = "_7r-e";